import { TAG_COLOR_TO_BAR_COLOR } from "@/constants/colors";
import type { DeadlineColor, DeadlineStatus, WorkflowColor, WorkflowStatus } from "@/types";

export const workflowStatusColorMap: Record<WorkflowStatus, WorkflowColor> = {
  created: "Neutral",
  pm_review: "Danger",
  drafting: "Info",
  ma_review: "Warning",
  le_review: "Warning",
  approved: "Success",
};

export const workflowStatusLabelMap: Record<WorkflowStatus, string> = {
  created: "Created",
  pm_review: "PM Review",
  drafting: "Drafting",
  ma_review: "MA Review",
  le_review: "LE Review",
  approved: "Approved",
};

export const workflowStatusBarColorMap = Object.fromEntries(
  Object.entries(workflowStatusColorMap).map(([k, v]) => [
    k,
    TAG_COLOR_TO_BAR_COLOR[v as WorkflowColor],
  ])
) as Record<WorkflowStatus, string>;

export const deadlineStatusColorMap: Record<DeadlineStatus, DeadlineColor> = {
  on_track: "Neutral",
  near_deadline: "Warning",
  overdue: "Danger",
};

export const deadlineStatusLabelMap: Record<DeadlineStatus, string> = {
  on_track: "On Track",
  near_deadline: "Near Deadline",
  overdue: "Overdue",
};

export const deadlineStatusBarColorMap = Object.fromEntries(
  Object.entries(deadlineStatusColorMap).map(([k, v]) => [
    k,
    TAG_COLOR_TO_BAR_COLOR[v as DeadlineColor],
  ])
) as Record<DeadlineStatus, string>;
